export const WHEEL_ITEM_HEIGHT = 32;
export const WHEEL_VISIBLE_COUNT = 7;
export const WHEEL_ITEM_ANGLE = 15;
export const WHEEL_PERSPECTIVE = 120;
export const WHEEL_FRICTION = 0.93;
export const WHEEL_VELOCITY_THRESHOLD = 0.3;
export const WHEEL_TOUCH_OVERSHOOT_PX = 60;
export const WHEEL_TOUCH_HISTORY_MS = 80;
export const WHEEL_SNAP_ANIMATION_MS = 240;
export const WHEEL_RENDER_COUNT = WHEEL_VISIBLE_COUNT + 4;
export const WHEEL_CENTER = Math.floor(WHEEL_VISIBLE_COUNT / 2);

export const WHEEL_FONT_SIZES = [22, 18, 14.5, 5] as const;
